import { gql, useQuery, QueryHookOptions } from '@apollo/client'

export interface SSOConfig {
  id: number
  provider: 'google' | 'okta'
  orgId: number
  issuer: string
  clientId: string
  redirectUri: string
}

export interface SSOConfigQueryResponse {
  getSSOConfig: SSOConfig
}

const SSO_CONFIG_QUERY = gql`
  query GetSSOConfig($subdomain: String!) {
    getSSOConfig(subdomain: $subdomain) {
      id
      provider
      orgId
      issuer
      clientId
      redirectUri
    }
  }
`

export const useSSOConfigQuery = (
  subdomain: string | null,
  options?: QueryHookOptions
) => {
  const { data, loading, error } = useQuery<SSOConfigQueryResponse>(SSO_CONFIG_QUERY, {
    variables: { subdomain },
    skip: !subdomain,
    fetchPolicy: 'cache-first',
    ...options
  })

  return {
    ssoConfig: data?.getSSOConfig ?? null,
    loading,
    error
  }
}
